// The only place money is turned into text. Currency comes from settings — never hardcoded.
export function money(n, settings, { decimals = 0, signed = false } = {}) {
  const v = Number(n) || 0;
  const sym = settings?.currencySymbol ? `${settings.currencySymbol} ` : '';
  const abs = Math.abs(v).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: 2 });
  const sign = v < 0 ? '−' : signed && v > 0 ? '+' : '';
  return `${sign}${sym}${abs}`;
}

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// month is 1–12, matching the database
export const periodLabel = (month, year) => (month && year ? `${MON[month - 1]} ${year}` : '—');
export const periodKey = (month, year) => `${year}-${String(month).padStart(2, '0')}`;
